"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.users = exports.searchTerm = exports.getUpdatedUsersState = exports.getUpdatedFoldersState = exports.getUpdatedFiltersState = exports.getStore = exports.folders = exports.filters = exports.defaultUsers = exports.defaultStoreState = exports.defaultItemBrowserState = exports.defaultEmptyStoreState = exports.default = exports.checkForCustomFilters = void 0;
var _filterGroupData = require("../utils/filterGroupData");
var _folderData = require("../utils/folderData");
var _userData = require("../utils/userData");
var _stateTypes = _interopRequireDefault(require("./stateTypes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getStore = function getStore(dataArr, defaultState) {
  var newStore = dataArr.reduce(function (acc, currentValue) {
    if (!acc[currentValue.id]) {
      acc[currentValue.id] = _objectSpread(_objectSpread({}, currentValue), {}, {
        state: currentValue.id === "allorgcontent" ? _stateTypes.default.USER_ITEM_ACTIVE : defaultState
      });
    }
    return acc;
  }, {});
  return {
    byId: newStore,
    allIds: Object.keys(newStore)
  };
};
exports.getStore = getStore;
var defaultEmptyStoreState = {
  byId: {},
  allIds: []
};
exports.defaultEmptyStoreState = defaultEmptyStoreState;
var getUpdatedFiltersState = function getUpdatedFiltersState(_ref) {
  var filters = _ref.filters,
    urlParams = _ref.urlParams;
  var activeParams = Object.keys(urlParams).filter(function (key) {
    return urlParams[key];
  });
  var activeParamValues = Object.values(urlParams).filter(function (key) {
    return key;
  });
  var updatedFilterGroups = filters.groups.allIds.reduce(function (acc, currentValue) {
    if (activeParams.includes(currentValue)) {
      acc[currentValue] = _objectSpread(_objectSpread({}, filters.groups.byId[currentValue]), {}, {
        state: _stateTypes.default.FILTER_GROUP_ACTIVE
      });
      // Handling for UI being updated based on existing URL params upon page load.  Following case handles url params with different key names in state from those used in AGO.
    } else if (currentValue === "created" && activeParams.includes("uploaded") || currentValue === "itemtype" && activeParams.includes("focus")) {
      acc[currentValue] = _objectSpread(_objectSpread({}, filters.groups.byId[currentValue]), {}, {
        state: _stateTypes.default.FILTER_GROUP_ACTIVE
      });
    } else {
      acc[currentValue] = filters.groups.byId[currentValue];
    }
    return acc;
  }, {});
  var updatedFilterItems = filters.items.allIds.reduce(function (acc, currentValue) {
    var itemId = currentValue.split("-")[0];
    var itemIdGroup = currentValue.split("-")[1];
    var itemTypeGroup = urlParams.focus ? urlParams.focus.split("-")[0] : null;
    switch (itemIdGroup) {
      case "modified":
        if (activeParamValues.includes(itemId) && activeParams.includes(itemIdGroup)) {
          acc[currentValue] = _objectSpread(_objectSpread({}, filters.items.byId[currentValue]), {}, {
            state: _stateTypes.default.FILTER_ITEM_ACTIVE
          });
        } else {
          acc[currentValue] = filters.items.byId[currentValue];
        }
        break;
      case "created":
        if (activeParamValues.includes(itemId) && activeParams.includes("uploaded")) {
          acc[currentValue] = _objectSpread(_objectSpread({}, filters.items.byId[currentValue]), {}, {
            state: _stateTypes.default.FILTER_ITEM_ACTIVE
          });
        } else {
          acc[currentValue] = filters.items.byId[currentValue];
        }
        break;
      default:
        if (itemTypeGroup === filters.items.byId[currentValue].urlField) {
          acc[currentValue] = _objectSpread(_objectSpread({}, filters.items.byId[currentValue]), {}, {
            state: _stateTypes.default.FILTER_ITEM_ACTIVE
          });
        } else {
          acc[currentValue] = filters.items.byId[currentValue];
        }
        break;
    }
    return acc;
  }, {});
  var updatedFilterState = _objectSpread(_objectSpread({}, filters), {}, {
    groups: {
      byId: updatedFilterGroups,
      allIds: Object.keys(updatedFilterGroups)
    },
    items: {
      byId: updatedFilterItems,
      allIds: Object.keys(updatedFilterItems)
    }
  });
  if (activeParams.includes("focus")) {
    var updatedFilterItemOptions = filters.itemOptions.allIds.reduce(function (acc, currentValue) {
      var itemIdGroup = urlParams.focus.split("-")[0];
      var itemTypeOption = null;
      if (urlParams.focus) {
        switch (itemIdGroup) {
          case "layers":
            itemTypeOption = urlParams.focus.split("-").slice(1, 3).join("-");
            break;
          default:
            itemTypeOption = urlParams.focus;
            break;
        }
      }
      if (filters.itemOptions.byId[currentValue].urlField === itemTypeOption) {
        acc[currentValue] = _objectSpread(_objectSpread({}, filters.itemOptions.byId[currentValue]), {}, {
          state: _stateTypes.default.FILTER_ITEM_OPTION_ACTIVE
        });
      } else {
        acc[currentValue] = filters.itemOptions.byId[currentValue];
      }
      return acc;
    }, {});
    updatedFilterState.itemOptions = {
      byId: updatedFilterItemOptions,
      allIds: Object.keys(updatedFilterItemOptions)
    };
  }
  return updatedFilterState;
};
exports.getUpdatedFiltersState = getUpdatedFiltersState;
var getUpdatedFoldersState = function getUpdatedFoldersState(_ref2) {
  var userFolders = _ref2.userFolders,
    currentUsername = _ref2.currentUsername,
    folderUrlParam = _ref2.folderUrlParam;
  var newFolders = userFolders.reduce(function (acc, currentValue) {
    var id = currentValue.id;
    if (!acc[id]) {
      acc[id] = {
        id: id,
        title: currentValue.title,
        state: folderUrlParam === id ? _stateTypes.default.FOLDER_ITEM_ACTIVE : _stateTypes.default.FOLDER_ITEM_DEFAULT
      };
    }
    return acc;
  }, {});
  var allmycontent = {
    id: "allmycontent",
    title: "All My Content",
    state: folderUrlParam === "allmycontent" || !folderUrlParam ? _stateTypes.default.FOLDER_ITEM_ACTIVE : _stateTypes.default.FOLDER_ITEM_DEFAULT
  };
  var root = {
    id: "root",
    title: currentUsername,
    state: folderUrlParam === "root" ? _stateTypes.default.FOLDER_ITEM_ACTIVE : _stateTypes.default.FOLDER_ITEM_DEFAULT
  };
  var byId = _objectSpread({
    allmycontent: allmycontent,
    root: root
  }, newFolders);
  var newStore = {
    items: {
      byId: byId,
      allIds: Object.keys(byId)
    }
  };
  return newStore;
};
exports.getUpdatedFoldersState = getUpdatedFoldersState;
var getUpdatedUsersState = function getUpdatedUsersState(_ref3) {
  var username = _ref3.username,
    userToAdd = _ref3.userToAdd,
    itemBrowserStateUsers = _ref3.itemBrowserStateUsers,
    userAlreadyAdded = _ref3.userAlreadyAdded,
    switchActiveAccount = _ref3.switchActiveAccount;
  var byId = itemBrowserStateUsers.byId;
  var updatedUsers = _objectSpread({}, byId);
  Object.keys(updatedUsers).forEach(function (key) {
    if (key !== username) {
      updatedUsers[key].state = _stateTypes.default.USER_ITEM_DEFAULT;
    } else {
      updatedUsers[key].state = _stateTypes.default.USER_ITEM_ACTIVE;
    }
  });
  if (!userAlreadyAdded) {
    var currentUser = {
      id: username,
      title: userToAdd.username ? userToAdd.username : userToAdd.title,
      alias: userToAdd.fullName ? userToAdd.fullName : userToAdd.alias,
      state: _stateTypes.default.USER_ITEM_ACTIVE
    };

    /* If actively logged-in user account changes, users state should be cleared out so that only the actively signed in user should display. Otherwise, simply add currentUser to state.*/
    if (switchActiveAccount) {
      updatedUsers = _defineProperty({}, username, currentUser);
    } else {
      updatedUsers = _objectSpread(_objectSpread({}, updatedUsers), {}, _defineProperty({}, username, currentUser));
    }
  }
  return updatedUsers;
};
exports.getUpdatedUsersState = getUpdatedUsersState;
var filterGroups = getStore(_filterGroupData.filterGroupTitles, _stateTypes.default.FILTER_GROUP_DEFAULT);
var filterItems = getStore(_filterGroupData.filterItemTitles, _stateTypes.default.FILTER_ITEM_DEFAULT);
var filterItemOptions = getStore(_filterGroupData.filterOptionItemTitles, _stateTypes.default.FILTER_ITEM_OPTION_DEFAULT);
var folderItems = getStore(_folderData.defaultFolderItemTitles, _stateTypes.default.FOLDER_ITEM_DEFAULT);
var userItems = getStore(_userData.userItemTitles, _stateTypes.default.USER_ITEM_DEFAULT);
var defaultUserItems = getStore(_userData.defaultEmptyUserItemTitles, _stateTypes.default.USER_ITEM_DEFAULT);
var filters = {
  groups: filterGroups,
  items: filterItems,
  itemOptions: filterItemOptions
};
exports.filters = filters;
var folders = {
  items: folderItems
};
exports.folders = folders;
var defaultUsers = {
  items: defaultUserItems
};
exports.defaultUsers = defaultUsers;
var users = {
  items: userItems
};
exports.users = users;
var searchTerm = "";
exports.searchTerm = searchTerm;
var defaultStoreState = {
  items: {
    byId: {},
    allIds: []
  }
};
exports.defaultStoreState = defaultStoreState;
var defaultItemBrowserState = {
  folders: defaultStoreState,
  users: defaultStoreState,
  searchTerm: ""
};
exports.defaultItemBrowserState = defaultItemBrowserState;
var store = {
  filters: filters,
  folders: folders,
  users: users,
  searchTerm: searchTerm
};
var checkForCustomFilters = function checkForCustomFilters(_ref4) {
  var customFilterGroupTitles = _ref4.customFilterGroupTitles,
    customItemTypesTitles = _ref4.customItemTypesTitles;
  var customFilterGroups = null;
  var customFilterItems = null;
  var customizedFilters = {};
  if (customFilterGroupTitles) {
    customFilterGroups = getStore(customFilterGroupTitles, _stateTypes.default.FILTER_GROUP_DEFAULT);
    customizedFilters = _objectSpread(_objectSpread({}, customizedFilters), {}, {
      groups: customFilterGroups
    });
  }
  if (customItemTypesTitles) {
    customFilterItems = getStore(customItemTypesTitles, _stateTypes.default.FILTER_ITEM_DEFAULT);
    customizedFilters = _objectSpread(_objectSpread({}, customizedFilters), {}, {
      items: customFilterItems
    });
  }
  if (Object.keys(customizedFilters).length) {
    return _objectSpread(_objectSpread({}, store), {}, {
      filters: _objectSpread(_objectSpread({}, store.filters), customizedFilters)
    });
  }
  return store;
};
exports.checkForCustomFilters = checkForCustomFilters;
var _default = store;
exports.default = _default;